import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import { useAuthContext } from 'src/auth/hooks';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import RestaurantFoodsListView from './restaurant-foods-list-view';

// ----------------------------------------------------------------------

export default function RestaurantFoodPageView() {
  const { user } = useAuthContext();

  if (!user?.restaurants[0]?.id) {
    return <div>No restaurant found</div>;
  }

  return (
    <PermissionBasedGuard permissions={['partners:read:foods']} hasContent>
      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading="Food"
          sx={{ mb: 2 }}
          links={[{}]}
          action={
            user?.restaurants[0].id && (
              <PermissionBasedGuard permissions={['partners:create:foods']}>
                <Button
                  component={RouterLink}
                  href={paths.dashboard.restaurant.food.add(user?.restaurants[0].id.toString())}
                  variant="contained"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                >
                  Add Food
                </Button>
              </PermissionBasedGuard>
            )
          }
        />

        <RestaurantFoodsListView id={user?.restaurants[0]?.id.toString()} />
      </Container>
    </PermissionBasedGuard>
  );
}
